(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["commission-product"]) return;
  try {
    
function initialiseCommissionOrder(root) {
  if (root.dataset.commissionInitialised) return;
  root.dataset.commissionInitialised = 'true';
  const optionInputs = Array.from(root.querySelectorAll('[data-commission-option]'));
  const variants = JSON.parse(root.querySelector('[data-commission-variants]').textContent);
  const variantId = root.querySelector('[data-commission-variant-id]');
  const price = root.querySelector('[data-commission-price]');
  const submitButton = root.querySelector('button[type="submit"]');
  const finishInput = root.querySelector('[data-commission-finish]');
  const mountNotice = root.querySelector('[data-commission-mount-notice]');
  const updateVariant = () => {
    const selected = optionInputs.map(input => input.value);
    const match = variants.find(variant => variant.options.every((value, index) => value === selected[index]));
    variantId.value = match ? match.id : '';
    variantId.dispatchEvent(new Event('change', { bubbles: true }));
    submitButton.disabled = !match || !match.available;
    price.textContent = match ? match.price : price.dataset.pendingPrice;
    if (mountNotice) mountNotice.hidden = !finishInput || finishInput.value !== 'Drawing mounted';
  };
  optionInputs.forEach(input => input.addEventListener('change', updateVariant));
  updateVariant();
  root.querySelectorAll('[data-commission-photo]').forEach(input => {
    input.addEventListener('change', () => {
      const oversized = Array.from(input.files).some(file => file.size > 10 * 1024 * 1024);
      input.setCustomValidity(oversized ? input.dataset.sizeError : '');
      if (oversized) input.reportValidity();
    });
  });
}
document.querySelectorAll('[data-commission-order]').forEach(initialiseCommissionOrder);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('[data-commission-order]').forEach(initialiseCommissionOrder);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["virtual-exhibition"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('virtual-exhibition')) {
  customElements.define('virtual-exhibition', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      if (!this.slides.length) return;
      this.index = 0;
      this.choice = this.querySelector('[data-choice]');
      this.querySelectorAll('[data-zoom]').forEach(button => {
        button.addEventListener('click', () => {
          if (Date.now() < (this.suppressZoomUntil || 0)) return;
          const zoomed = button.getAttribute('aria-pressed') !== 'true';
          const picture = button.querySelector('img');
          if (picture) {
            picture.dataset.baseSizes ||= picture.sizes;
            picture.sizes = zoomed ? `${Math.ceil(button.clientWidth * 2)}px` : picture.dataset.baseSizes;
          }
          button.setAttribute('aria-pressed', String(zoomed));
          button.setAttribute('aria-label', zoomed ? button.dataset.zoomOut : button.dataset.zoomIn);
        }, options);
      });
      this.counter = this.querySelector('[data-counter]');
      this.querySelectorAll('[data-prev]').forEach(button => button.addEventListener('click', () => this.navigate(this.index - 1, button), options));
      this.querySelectorAll('[data-next]').forEach(button => button.addEventListener('click', () => this.navigate(this.index + 1, button), options));
      this.choice.addEventListener('change', () => this.show(Number(this.choice.value)), options);
      this.addEventListener('keydown', event => {
        if (event.target.closest('select, input, textarea') || event.altKey || event.ctrlKey || event.metaKey) return;
        const targets = { ArrowLeft: this.index - 1, ArrowRight: this.index + 1, Home: 0, End: this.slides.length - 1 };
        if (event.key in targets) { event.preventDefault(); this.show(targets[event.key]); }
      }, options);
      this.querySelectorAll('[data-swipe]').forEach(figure => {
        let start;
        figure.addEventListener('touchstart', e => { start = [e.changedTouches[0].clientX, e.changedTouches[0].clientY]; }, { ...options, passive: true });
        figure.addEventListener('touchend', e => {
          if (!start) return;
          const dx = e.changedTouches[0].clientX - start[0], dy = e.changedTouches[0].clientY - start[1];
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            this.suppressZoomUntil = Date.now() + 500;
            this.show(this.index + (dx < 0 ? 1 : -1));
          }
          start = null;
        }, { ...options, passive: true });
      });
      document.addEventListener('shopify:block:select', e => {
        if (!this.contains(e.target)) return;
        const index = this.slides.findIndex(s => s === e.target || s.contains(e.target));
        if (index >= 0) this.show(index);
      }, options);
      this.dataset.ready = '';
      this.show(0);
      this.querySelectorAll('[data-controls]').forEach(control => { control.hidden = this.slides.length < 2; });
    }
    navigate(index, button) {
      this.show(index);
      if (button.closest('.ve__bottom-nav')) this.scrollIntoView({ block: 'start' });
    }
    show(index) {
      this.querySelectorAll('[data-zoom]').forEach(button => {
        const picture = button.querySelector('img');
        if (picture?.dataset.baseSizes) picture.sizes = picture.dataset.baseSizes;
        button.setAttribute('aria-pressed', 'false');
        button.setAttribute('aria-label', button.dataset.zoomIn);
      });
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.choice.value = String(this.index);
      this.counter.textContent = `${this.index + 1} ${this.counter.dataset.of} ${this.slides.length}: ${this.slides[this.index].dataset.title}`;
      const next = this.slides[(this.index + 1) % this.slides.length].querySelector('img');
      if (next) next.loading = 'eager';
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}

  } catch(e) { console.error(e); }
})();
})();
